import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  MenuItem,
  Grid,
  IconButton
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import NewsActions from 'stores/leadbest-official-website/news/actions'
import NewsSidebar from './NewsSidebar';
import MobileBanner from './MobileBanner'
import MenuTypes from './menuTypes.json'
import { Helmet } from "react-helmet-async";
import { Link, useHistory } from "react-router-dom";
import languages from 'locales';
import Hidden from '@material-ui/core/Hidden';
import quoteLeft from './../../assets/images/quote-left.png'
import quoteRight from './../../assets/images/quote-right.png'
import iconFacebook from './../../assets/images/icon-facebook-circle.png'
import iconLinkedin from './../../assets/images/icon-linkedin-circle.png'
import iconTwitter from './../../assets/images/icon-twitter-circle.png'
import iconLink from './../../assets/images/icon-link-circle.png'
import { Scene } from 'react-scrollmagic';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { injectIntl, FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor:"#fff",
      '& img': {
        display: 'block',
        width: '100%'
      },
      [theme.breakpoints.down('sm')]: {

      }
    },
    btnGroup: {
      margin: '0 -8px',
      '& > *': {
        margin: theme.spacing(1)
      }
    },
    section1: {
      height: 450,
      backgroundSize: 'cover',
      backgroundPosition: 'top center',
      padding: 0,
      [theme.breakpoints.down('sm')]: {
        height: 188,
      },
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover"
      }
    },
    newSection: {
      padding: '80px 24px 100px 24px',
      [theme.breakpoints.down('sm')]: {
        padding: '25px 24px 60px 24px'
      },
      '& .section-content': {
        position: "relative",
        maxWidth: 1196,
        margin: 'auto',
        width: '100%',
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column'
        }

      },
      '& .news-list': {
        flex: 1
      },

      '& .news-title': {
        margin: "0px 0px 16px 0px",
        fontSize: "36px",
        fontWeight: "bold",
        [theme.breakpoints.down('sm')]: {
          fontSize: "28px",
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: "20px",
        }
      },
      '& .news-tags': {
        marginBottom: '24px',
        userSelect: 'none'
      },
      '& .news-time': {
        color: 'rgba(3, 7, 31, 0.65)'
      },
      '& .news-content': {
        margin: "0px 0px 32px 0px",
        color: 'rgba(2,6,30,0.85)',
        fontSize: "16px",
        lineHeight: "26px",
        opacity: "0.7",
        [theme.breakpoints.down('xs')]: {
          fontSize: "14px",
        }
      },
      '& .news-caption': {
        margin: "0px 0px 32px 0px",
        textAlign: 'center',
        color: 'rgba(2,6,30,0.4)',
        '& .MuiTypography-caption': {
          fontSize: '14px'
        }
      },
      '& .news-link': {
        fontSize: '14px',
        color: 'rgba(2,6,30, 0.85)',
        '& a': {
          wordBreak: "break-word",
          color: "rgba(2,6,30, 0.85)",
          textDecoration: "underline"
        }
      },
      '& .news-divider': {
        width: "100%",
        height: '2px',
        backgroundColor: "rgba(0,0,0,0.04)"
      },
      '& .news-blockQuote': {
        fontWeight: "500",
        textAlign: "center",
        margin: "0px auto 32px auto",
        position: "relative",
        padding: "50px 60px",
        fontSize: "20px",
        lineHeight: "27px",
        [theme.breakpoints.down('sm')]: {
          padding: "24px",
        }
      },
      "& .quote": {
        position: "absolute",
        width: "36px",
        height: "27px",
        "&.left": {
          top: "0px",
          left: "0px"
        },
        "&.right": {
          bottom: "0px",
          right: "0px"
        },
        [theme.breakpoints.down('sm')]: {
          width: "16px",
          height: "12px"
        }
      },
      '& .news-heading1': {
        margin: "0px 0px 16px 0px",
        fontSize: "36px",
        fontWeight: "bold",
        [theme.breakpoints.down('sm')]: {
          fontSize: "22px",
        }
      },
      '& .news-heading2': {
        margin: "0px 0px 16px 0px",
        fontSize: "20px",
        fontWeight: "500",
        [theme.breakpoints.down('sm')]: {
          fontSize: "16px",
        }
      },
      '& .news-picture': {
        width: "100%",
        height: "auto",
        '& img': {
          objectFit: "contain",
        },
      },
      '& .news-lineBreak': {
        height: '14px'
      },
      '& .news-filter': {
        width: 272,
        marginLeft: 49,
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          marginLeft: 0,
        }
      },
      '& .filter-item': {
        display: 'flex',
        padding: '20px 0',
        cursor: 'pointer',
        '&:hover': {
          '& .filter-title': {
            color: '#8b3d2b'
          }
        },
        '& .filter-title': {
          color: 'rgba(3, 7, 31, 0.85)'
        },
        '& + .filter-item': {
          borderTop: 'solid 1px rgba(3, 7, 31, 0.15)'
        },
        '& .filter-pic': {
          marginRight: 16,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
          width: 75,
          height: 75
        },
      },
      "& .button-group": {
        position: "absolute",
        top: "170px",
        left: "-80px",
        "& img": {
          width: "48px",
          height: "48px"
        },
        "& button": {
          padding: "0px",
          margin: "12px 0px"
        }
      },
      "& .button-title": {
        fontSize: "16px",
        color: "#001229",
        fontWeight: "normal"
      }
    },
    tags: {
      marginBottom: 8,
      '& > *': {
        border: 'solid 1px rgba(3, 7, 31, 0.15)',
        borderRadius: 4,
        padding: '4px 12px',
        fontSize: 14,
        color: 'rgba(3, 7, 31, 0.65)',
        marginRight: 8,
        marginBottom: 8,
        display: 'inline-block'
      }
    },
    relative: {
      maxWidth: 1244,
      margin: "auto",
      position: "relative",
      padding: '0 24px',
      "& .relative-title": {
        position: "relative",
        zIndex: "1",
        fontSize: "20px",
        margin: "0px auto",
        width: "fit-content",
        padding: "0px 36px",
        fontWeight: "600",
        color: "#001229",
        background: "#fff",
      },
      "& .divider": {
        width: "calc(100% - 48px)",
        height: "2px",
        display: "block",
        position: "absolute",
        background: "#001229",
        top: "14px",
        left: "24px"
      },
      "& .news-block": {
        padding: "56px 0px 30px 0px",
        [theme.breakpoints.down('sm')]: {
          padding: "40px 0px 30px 0px",
        }
      },
      "& .news-card": {
        cursor: "pointer",
        "&:hover": {
          "& .news-picture": {
            transform: "scale(1.1)",
          }
        }
      },
      "& .picture-block": {
        width: "100%",
        height: "264px",
        overflow: "hidden",
        [theme.breakpoints.down('xs')]: {
          height: "225px",
        }
      },
      "& .news-picture": {
        objectFit: "cover",
        transform: "scale(1)",
        transition: "0.3s",
        width: "100%",
        height: "100%",
      },
      "& .news-title": {
        fontSize: "20px",
        color: "#001229",
        fontWeight: "500",
        margin: "12px 0px 0px 0px",
        minHeight: "80px",
        [theme.breakpoints.down('xs')]: {
          fontSize: "16px",
          minHeight: "60px",
        }
      },
    }
  })
);

export enum ArticleStatus {
  ARCHIVED = 'archived',
  PUBLISHED = 'published',
}

const DetailPage = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory()
  const newsSelector = useSelector((state: any) => state.leadbest.news);
  const newsDetails = newsSelector.newsDetails
  const { id, isMobileScreen, intl } = props
  const global = useSelector((state: any) => state.global);
  const languagesIndex = languages[global.locale].id;

  useEffect(() => {
    if (newsDetails.loading) return;
    dispatch(NewsActions.getNewsdetailsRequest({ params: {}, id: id }));
  }, [id])

  // 判斷此文章是否有公開發佈，如果沒有就導頁去 404
  useEffect(() => {
    if(newsDetails.loading) return;

    const { status } = newsDetails.data
    if(!!status){
      const articleIsNotPublished = status !== ArticleStatus.PUBLISHED
      if(articleIsNotPublished){
        history.push('/404')
      }
    }
  },[newsDetails])

  const correspondingLanguage = (translations: any) => {
    const language = languagesIndex == 0 ? 'zh-TW' : 'en-US'
    return translations.find((item: any) => item.languages_id.code == language)
  }

  const translationData = (translations: any) => {
    return translations.find((item: any) => item.languages_id.code.toLowerCase() == global.locale.replace('_', '-').toLowerCase())
  }
  const handleCopy = () => {
    /* Select the text field */
    // copyText.select();
    // copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    document.execCommand("copy");
    alert(intl.formatMessage({ id: "newsDetails.copyAlert" }))

  }

  const innerTextLink = (content: any) => {
    const rule: RegExp = /&link;(\S*)&link;/
    const substr: any = content.match(rule);
    if (substr == null) return content;
    const marchString = substr['0']
    const linkData = JSON.parse(substr['1'])
    return content.replace(marchString, `<a href=${linkData[1]} target="_blank" rel="noreferrer noopener">${linkData[0]}</a>`)
  }
  return (
    <Box className={clsx(classes.root, 'bannerTrigger')}>

      {/* --- SEO --- */}
      {
        !newsDetails.loading && newsDetails.loaded &&
        <Helmet>
          {/* 先調整成抓中文，之後Lb-tool的Router升級後，再改成抓當下的語系 */}
            <title>{translationData(newsDetails.data.translations)?.title}</title>
            <meta name="description" content={translationData(newsDetails.data.translations)?.contents.find((item: any) => item.type == "TEXT")?.content} />
            <meta property="og:url" content={`https://www.leadbestgroup.com${history.location.pathname}`} />
            <meta property="og:type" content="article" />
            <meta property="og:title" content={translationData(newsDetails.data.translations)?.title} />
            <meta property="og:description" content={translationData(newsDetails.data.translations)?.contents.find((item: any) => item.type == "TEXT")?.content} />
            <meta property="og:image" content={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${newsDetails.data.cover?.id}&fit=cover&width=600&height=400`} />
            <meta property="fb:app_id" content={`${window.Config.FB_APP_ID}`} />
          {/* <title>{correspondingLanguage(newsDetails.data.translations)?.title}</title>
          <meta name="description" content={correspondingLanguage(newsDetails.data.translations)?.contents.find((item: any) => item.type == "TEXT")?.content} />
          <meta property="og:url" content={`https://www.leadbestgroup.com${history.location.pathname}`} />
          <meta property="og:type" content="article" />
          <meta property="og:title" content={correspondingLanguage(newsDetails.data.translations)?.title} />
          <meta property="og:description" content={correspondingLanguage(newsDetails.data.translations)?.contents.find((item: any) => item.type == "TEXT")?.content} />
          <meta property="og:image" content={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${newsDetails.data.cover?.id}&fit=cover&width=600&height=400`} /> */}
        </Helmet>
      }

      {/* --- Banner --- */}

      {/* <Hidden smDown> */}
      {newsDetails.loading &&
        <Skeleton animation="wave" variant="rect" height={isMobileScreen ? 188 : 450} width="100%" />
      }
      {!newsDetails.loading && newsDetails.loaded &&
        <Box className={clsx('section1', classes.section1)}  >
          <img src={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${newsDetails.data.header_image?.id}?fit=cover&width=${isMobileScreen ? 400 : 1900}&height=${isMobileScreen ? 200 : 450}`} alt={newsDetails.data.header_image.description || newsDetails.data.id} />
        </Box>
      }
      {/* </Hidden> */}

      {/* <Hidden only={['md', 'lg', 'xl']}>
        <MobileBanner />
      </Hidden> */}

      {/* --- Article --- */}

      <Box className={classes.newSection}>
        <Box className="section-content">
          <Box className="news-list">
            {
              newsDetails.loading &&
              (<Box>
                <Skeleton animation="wave" variant="rect" height={isMobileScreen && 40 || 50} width="80%" style={{ marginBottom: 24 }} />
                <Skeleton animation="wave" variant="rect" height={18} width={isMobileScreen && '220px' || '26%'} style={{ marginBottom: 12 }} />
                <Skeleton animation="wave" variant="rect" height={26} width={isMobileScreen && '90px' || '10%'} style={{ marginBottom: 48 }} />
                <Skeleton animation="wave" variant="rect" height={36} width="60%" style={{ marginBottom: 24 }} />
                <Skeleton animation="wave" variant="rect" height={isMobileScreen && 160 || 200} width="100%" style={{ marginBottom: 48 }} />
                <Skeleton animation="wave" variant="rect" height={36} width="60%" style={{ marginBottom: 24 }} />
                <Skeleton animation="wave" variant="rect" height={isMobileScreen && 160 || 200} width="100%" style={{ marginBottom: 48 }} />
                <Skeleton animation="wave" variant="rect" height={isMobileScreen && 200 || 480} width="100%" style={{ marginBottom: 20 }} />
                <Skeleton animation="wave" variant="rect" height={20} width="30%" style={{ margin: "0px auto 60px auto" }} />
                <Skeleton animation="wave" variant="rect" height={20} width={isMobileScreen && '180px' || '30%'} style={{ marginBottom: 100 }} />
              </Box>)
            }
            {
              !newsDetails.loading && newsDetails.loaded && (
                <>
                  <h1 className="news-title">{correspondingLanguage(newsDetails.data.translations)?.title}</h1>
                  <Box className="news-time" mb={2}>{`${moment(newsDetails.data.date_published).format('YYYY.MM.DD')} / ${intl.formatMessage({ id: `newsList.menuType.${newsDetails.data.category}` })} / ${correspondingLanguage(newsDetails.data.translations)?.publisher}`}</Box>
                  <Box className={clsx(classes.tags, 'news-tags')} >
                    {
                      newsDetails.data.tags?.map((tag: any, key: any) => <Box key={key}>{tag.news_tags_id.name}</Box>)
                    }
                  </Box>
                  {
                    correspondingLanguage(newsDetails.data.translations)?.contents.map((item: any, index: any) => {
                      switch (item.type) {
                        case 'TEXT':
                          return <p className="news-content" key={index} dangerouslySetInnerHTML={{ __html: innerTextLink(item.content) }} />
                        case 'IMAGE':
                          return <Box mb={2} className="news-picture" key={index}><img src={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.image}&width=${isMobileScreen ? 320 : 862}`} alt={item.content || ""} /></Box>
                        case 'YOUTUBE_VIDEO':
                          return <Box mb={4} className="news-video" key={index}><iframe width="100%" height={isMobileScreen && '185px' || '492px'} src={`https://www.youtube.com/embed/${item.content.split('?v=')[1]}`} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></Box>
                        case 'LINK':
                          return <Box mb={4} className="news-link" key={index}>{intl.formatMessage({ id: "newsDetails.newsSource" })}<a href={item.content} target="_blank" rel="noreferrer noopener">{item.content}</a></Box>
                        case 'HORIZONTAL_LINE':
                          return <Box mb={4} className="news-divider" key={index} />
                        case 'CAPTION':
                          return <p className="news-caption" key={index}>{item.content}</p>
                        case 'LINE_BREAK':
                          return <Box mb={Number(item.content)} className="news-lineBreak" key={index} />
                        case 'BLOCK_QUOTE':
                          return <blockquote className="news-blockQuote" key={index}>
                            <img className="quote left" src={quoteLeft} alt="quote-left-icon" />
                            {item.content}
                            <img className="quote right" src={quoteRight} alt="quote-right-icon" />
                          </blockquote>
                        case 'HEADING_1':
                          return <h2 className="news-heading1" key={index}>{item.content}</h2>
                        case 'HEADING_2':
                          return <h3 className="news-heading2" key={index}>{item.content}</h3>

                        default:
                          return null;
                      }
                    })
                  }
                </>
              )
            }

          </Box>
          <div>
            <Hidden smDown>
              <NewsSidebar />
            </Hidden>
          </div>

          {/* share button group */}

          <Hidden mdDown>
            <div>
              <Scene triggerHook={0.075} duration={1050} pin={!isMobileScreen} >
                <Box className="button-group" display="flex" alignItems="center" flexDirection="column">
                  <div className="button-title">{intl.formatMessage({ id: "newsDetails.share" })}</div>
                  <a target="_blank" rel="noreferrer noopener" href={`https://www.facebook.com/sharer/sharer.php?u=https://www.leadbestgroup.com${history.location.pathname}&amp;src=sdkpreparse`}>
                    <IconButton>
                      <img src={iconFacebook} alt="share to facebook" />
                    </IconButton>
                  </a>
                  <a target="_blank" rel="noreferrer noopener" href={`https://www.linkedin.com/cws/share?url=https://www.leadbestgroup.com${history.location.pathname}`} >
                    <IconButton><img src={iconLinkedin} alt="share to linkedIn" /></IconButton>
                  </a>
                  <a target="_blank" rel="noreferrer noopener" href={`https://twitter.com/intent/tweet?text=https://www.leadbestgroup.com${history.location.pathname}`} >
                    <IconButton><img src={iconTwitter} alt="share to twitter" /></IconButton>
                  </a>
                  <CopyToClipboard text={`https://www.leadbestgroup.com${history.location.pathname}`}>
                    <IconButton onClick={() => handleCopy()}><img src={iconLink} alt="copy news url" /></IconButton>
                  </CopyToClipboard>
                </Box>
              </Scene>
            </div>
          </Hidden>

        </Box>
      </Box>

      {/* --- Related News --- */}

      <div className={classes.relative}>
        <div className="relative-title">{intl.formatMessage({ id: "newsDetails.relativedNews" })}</div>
        <div className="divider" />
        <Grid container spacing={3} className="news-block">
        {!newsDetails.loading && newsDetails.loaded && newsDetails.data.related_news?.map((item: any, index: number) =>
            <Grid xs={12} sm={6} md={4} key={index} item >
              <Link className="news-card" to={`/news/${item.related_news_id.id}`}>
                <div className="picture-block">
                  <img className="news-picture" src={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.related_news_id.cover.id}?fit=cover&width=380&height=260`} alt={item.related_news_id.cover.description || item.related_news_id.cover.id} />
                </div>
                <div className="news-title">{correspondingLanguage(item.related_news_id.translations)?.title}</div>
              </Link>
            </Grid>
          )}
        </Grid>
      </div>
    </Box >
  )
}


export default injectIntl(DetailPage)